import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sendMessage } from "../../actions";

//style
import "./style.scss";

// components
import Input from "../../components/Input";
import Spinner from "../../components/Spinner";

// svg
import { ReactComponent as MailIcon } from "../../assets/images/mail.svg";
import { ReactComponent as UserIcon } from "../../assets/images/user.svg";

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const mail = useSelector((state) => state.mail);

  const dispatch = useDispatch();

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(sendMessage({ name, email, message }));
    setName("");
    setEmail("");
    setMessage("");
  };

  return (
    <div id="contact">
      <div className="contact-left">
        <h2 className="heading">Hire Tousif Ahmed</h2>
        <p className="sub-heading">
          I will get back to you within 24 hours. Send me a mail.
        </p>
        <div className="contact-options">
          <div className="email">
            <br />
            <MailIcon className="mail-icon" />
            <p>tousifprovat15@gmail.com</p>
          </div>
        </div>
      </div>
      <div className="contact-right">
        {mail.message && (
          <p style={{ textAlign: "center", color: "#198754" }}>
            Your message sent successfully!
          </p>
        )}
        {mail.loading && <Spinner />}
        {!mail.loading && !mail.message && (
          <div
            className="form-box"
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            <form onSubmit={onSubmit}>
              <Input
                inputType={"text"}
                placeholder={"Your name"}
                inputValue={name}
                onChange={(e) => setName(e.target.value)}
              >
                <UserIcon strokeWidth={"2"} />
              </Input>
              <Input
                inputType={"email"}
                placeholder={"Your email"}
                inputValue={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              >
                <MailIcon strokeWidth={"2"} />
              </Input>
              <textarea
                placeholder="Your message"
                name="message"
                id="consumers_message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
              <button className="send" aria-label="send" type="submit">
                <i className="fas fa-paper-plane "></i>
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}
